import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { ReactSVG } from 'react-svg';
import Images from '../Theme/Images';
import DoubleArrowIcon from '@material-ui/icons/DoubleArrow';
class SchedulerBg extends Component {

    getPageNo = () => {
        if (this.props.history.location.pathname.toLowerCase() === '/selectdate')
            return '02'
        else if (this.props.history.location.pathname.toLowerCase() == '/')
            return '01'
        else
            return '03'
    }

    onLogoClick = () => {
        let link = document.createElement('a');
        link.target = '_blank'
        link.href = 'https://amygb.ai/idp-platform'
        document.body.appendChild(link);
        link.click();
    }


    render() {
        const { type } = this.props
        return (
            type === 'trial' ?
                <div className='schedulerBgContainer  trialBgContainer fullHeight colFlex' style={{ justifyContent: 'space-between', paddingBottom: '5%', height: '92%' }}>
                    <div >
                        <div className='rowFlex' style={{ justifyContent: 'space-between' }}>
                            {/*<img src={Images.visionLogo} style={{ width: '30%', cursor: 'pointer' }} onClick={this.onLogoClick} />*/}
                            <img src={Images.whiteLogo} style={{ width: '30%', cursor: 'pointer' }} onClick={this.onLogoClick} />
                        </div>
                        <div className='trialDetails'>
                            <div className='subHeading3 semiBold'>Decode your documents at scale with <span style={{color: '#f2d900'}}>VisionERA</span>:</div>
                            <br/>
                            <div className='desc'>
                                <div className='vision-point'>
                                    <DoubleArrowIcon />&nbsp;&nbsp;
                                    <div className='colFlex flexCenter'>End to end AI powered document process automation</div>
                                </div>
                                <div className='vision-point'>
                                    <DoubleArrowIcon />&nbsp;&nbsp;
                                    <div className='colFlex flexCenter'>Real time intelligent analytics</div>
                                </div>
                                <div className='vision-point'>
                                    <DoubleArrowIcon />&nbsp;&nbsp;
                                    <div className='colFlex flexCenter'>Auto-learning with built in feedback mechanism</div>
                                </div>
                                <div className='vision-point'>
                                    <DoubleArrowIcon />&nbsp;&nbsp;
                                    <div className='colFlex flexCenter'>Easy, self configurable data validation workflows</div>
                                </div>
                                <div className='vision-point'>
                                    <DoubleArrowIcon />&nbsp;&nbsp;
                                    <div className='colFlex flexCenter'>Seamless integration with any platform</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                :
                <div className='schedulerBgContainer fullHeight'>
                    <div className='pageSubHeading extraBold bgHeading'>{type === 'trial' ? 'Register Now' : 'Book a Demo'}</div>
                    <div className='subHeading1 semiBold'>{type === 'trial' ? 'Get your free 7 day trial. No credit card needed!' :
                        'Looking for the perfect automation solution? Our experts would be delighted to tell you more.'}</div>
                    <br />
                    <div className='schedulerBg'></div>
                    {type === 'trial' ? null : <div className='pageNoContainer'><span className='subHeading1 semiBold allPage'>{this.getPageNo()}</span><span className='desc  allPage'>&nbsp;/&nbsp;03</span></div>
                    }            </div>
        )
    }
}
SchedulerBg.propTypes = {
    classes: PropTypes.object.isRequired,
};
export default withRouter(SchedulerBg);
